import axios from 'axios';
import Config from '@/Config';

axios.defaults.withCredentials = true;

const host = `${Config.host}/usuarios/`

function Login(usuario, clave){
    const url = `${host}Login.php`
    return axios.post(url,{
        usuario: usuario,
        clave: clave
    }).then(response =>
        response.data
    );
}
function ValidarLogin(){
    const url = `${host}ValidarLogin.php`
    return axios.get(url).then(response =>
        response.data
    );
}
function SalirLogin(){
    const url = `${host}SalirLogin.php`
    return axios.get(url).then(response =>
        response.data
    );
}

function DarInfoUserLogin(){
    const url = `${host}DarInfoUserLogin.php`
    return axios.get(url).then(response =>
        response.data
    );
}
export {
    Login,
    ValidarLogin,
    SalirLogin,
    DarInfoUserLogin
}
